<template>
    <Modal
        v-model="show_modal"
        title="修改收货地址"
        :mask-closable="false"
        width="640"
        @on-cancel="close"
    >
        <div class="modify-address">
            <div class="form-item">
                <div class="label">收货人：</div>
                <div class="value">
                    <Input v-model="form.contact_person" placeholder="请输入收货人姓名" :maxlength="30" />
                </div>
            </div>
            <div class="form-item">
                <div class="label">联系电话：</div>
                <div class="value">
                    <Input v-model="form.contact_mobile" placeholder="请输入收货人手机号码" :maxlength="11" />
                </div>
            </div>
            <div class="form-item">
                <div class="label">所在地区：</div>
                <div class="value">
                    <Cascader :data="region" v-model="value" placeholder="请选择省/市/区" style="width:100%" />
                </div>
            </div>
            <div class="form-item">
                <div class="label">详细地址：</div>
                <div class="value">
                    <Input v-model="form.address" type="textarea" :rows="3" placeholder="请输入详细地址" />
                </div>
            </div>
        </div>
        <div slot="footer">
            <div class="footer-btn-box">
                <div class="btn cancel" @click="close">取消</div>
                <div class="btn confirm" :class="{ disabled: saving }" @click="save">确定</div>
            </div>
        </div>
    </Modal>
</template>
<script>
import region from '@/utils/region.js';
import { shopOrderReviseAddress } from '@/api/index';
export default{
    name:"ModifyAddress",
    data(){
        return {
            show_modal:false,
            saving:false,
            region,
            order_uuid:'',
            value:[],
            form:{
                contact_person:'',
                contact_mobile:'',
                address:''
            }
        }
    },
    methods:{
        showEdit(order){
            this.saving = false;
            this.order_uuid = order.uuid;
            this.form = {
                contact_person: order.contact_person || '',
                contact_mobile: order.contact_mobile || '',
                address: order.address || ''
            };
            this.value = [order.province, order.city, order.zone].filter(Boolean);
            this.show_modal = true;
        },
        close(){
            this.show_modal = false;
            this.$nextTick(()=>{
                this.$emit('close');
            });
        },
        validate(){
            if(!this.form.contact_person){
                return '请填写收货人姓名';
            }
            if(!/^1\d{10}$/.test(this.form.contact_mobile)){
                return '请填写正确的手机号码';
            }
            if(this.value.length !== 3){
                return '请选择省市区';
            }
            if(!this.form.address){
                return '请填写详细地址';
            }
            return '';
        },
        async save(){
            const err = this.validate();
            if(err){
                this.$layer.msg(err);
                return;
            }
            if(this.saving) return;
            this.saving = true;
            try{
                const [province, city, zone] = this.value;
                const param = {
                    uuid: this.order_uuid,
                    contact_person: this.form.contact_person,
                    contact_mobile: this.form.contact_mobile,
                    province,
                    city,
                    zone,
                    address: this.form.address
                };
                const {code,msg} = await shopOrderReviseAddress(param);
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('修改成功~');
                this.$emit('saved', param);
                this.close();
            }catch(e){
                console.log('err-modify-address',e);
                this.$layer.msg(e.msg || '修改失败，请稍后重试');
            }finally{
                this.saving = false;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .modify-address{
        .form-item{
            display:flex;
            align-items:flex-start;
            margin-bottom:20px;
            .label{
                width:86px;
                flex-shrink:0;
                color:#333;
                font-size:14px;
                line-height:32px;
                text-align:right;
                padding-right:8px;
                &::after{
                    content:"*";
                    color:#ff5967;
                    margin-left:2px;
                }
            }
            .value{
                flex:1;
            }
        }
    }
    .footer-btn-box{
        display:flex;
        justify-content:center;
        column-gap:12px;
        .btn{
            height:36px;
            line-height:36px;
            padding:0 32px;
            border-radius:4px;
            font-size:14px;
            cursor:pointer;
            &.cancel{
                border:1px solid #e3e3e3;
                color:#666;
                background:#fff;
            }
            &.confirm{
                background:#ff5967;
                color:#fff;
                font-weight:bold;
                &.disabled{
                    opacity:0.6;
                    pointer-events:none;
                }
            }
        }
    }
    ::v-deep .ivu-modal-footer{
        border-top:none;
        padding:0 0 24px 0;
    }
</style>
